/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgInfoletPlay = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 2h20v12h-2V8H4v12h9v2H2zm2 4h16V4H4z" />
        <path d="M6 10h6v8H6zm2 2v4h2v-4zm10-2h-4v2h4zm4.944 8L15 13.234v9.532zm-3.888 0L17 19.234v-2.468z" />
      </g>
    </g>
  </Icon>
);
export { SvgInfoletPlay as InfoletPlay };
